module.exports = __webpack_public_path__ + "static/media/maxbountyreferral-160x600.4d3dd1fe.jpg";